import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import customizableQuery from '~/graphql/customizable.gql';
function fetchCustomizable(_x, _x2) {
  return _fetchCustomizable.apply(this, arguments);
}
function _fetchCustomizable() {
  _fetchCustomizable = _asyncToGenerator(function* (context, code) {
    var locale = context.state.i18n.currentLocale.iso;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.query({
      query: customizableQuery,
      variables: {
        locale,
        code
      }
    });
    return data.customizable;
  });
  return _fetchCustomizable.apply(this, arguments);
}
export { fetchCustomizable };